<script setup>
const modelValue = defineModel();
const props = defineProps({
    options: {
        type: Array,
        required: true
    },
    name: {
        type: String,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    },
});

const emit = defineEmits(['update:modelValue']);

const isActiveOption = (option) => {
    return modelValue.value === option.value || ('' + modelValue.value) === ('' + option.value);
};

</script>

<template>
    <div class="input-wrapper star-cb-group no-stars-layout">
        <div class="d-inline-block" :class="'toggle-option--' + option.label" v-for="option in options" :key="option.value">
            <input type="radio"
                   class="d-none"
                   :id="name + option.value"
                   :name="name"
                   :value="option.value"
                   :disabled="disabled"
                   :checked="isActiveOption(option)"
                   @change="emit('update:modelValue', $event.target.value)"
            >
            <label
                class="number-selector"
                :class="{active: isActiveOption(option)}"
                :for="name + option.value"
            >
                {{option.label}}
            </label>
        </div>
    </div>
</template>
